import React from 'react';
import { NavLink } from 'react-router-dom';

export default function MerchantKyc() {
	return (
		<main className="pt-20 lg:pt-10 px-1 pb-20 2xl:px-10">
			<div>
				<h1 className="mb-10">Merchant KYC</h1>
				<div className="w-100 h-[1px] bg-gray-400" />
			</div>
			<div className="flex-1 lg:flex lg:flex-row pb-20 overflow-scroll">
				<div className="lg:basis-4/5 w-full">
					<div className="flex space-x-2 mt-10 bg-orange-50 p-5 pl-5 border-l-2 border-[orange]">
						<div>👍</div>
						<div>
							<div>
								<h2 className="text-lg font-bold text-[orange]">KYC STATUS</h2>
							</div>
							<div>
								<h2 className="text-base">
									There is a section at the top of the dashboard page that list
									the status of all the required KYC.
								</h2>
							</div>
						</div>
					</div>
					<div className="flex flex-col justify-center items-center">
						<img
							src={require('../../assets/Image/MerchantKYC1.png')}
							alt="MerchantKyc"
							className="w-full mt-5 mb-2"
							width={628}
							height={74}
						/>
						<p className="text-center mb-8">Kyc Status Panel</p>
					</div>
					<div id="kyc-verification"></div>
					<div>
						<h3 className="mb-2">KYC VERIFICATION</h3>
						<p className="">
							Now that you have access to view your dashboard, you are allowed
							to make transactions with your account. However, you will not
							receive settlements until you submit all the required documents
							and they are verified.
						</p>
						<p className="">
							There are three steps to the verification process, and you have
							completed one by completing the business information stage in
							Merchant Registration
						</p>
						<div className="mt-2 ml-2 md:ml-5">
							<ol>
								<li className="text-sm">1. Business Information - Completed</li>
								<li className="text-sm">2. Profile Verification - Pending</li>
								<li className="text-sm">3. Bank Account Details - Pending</li>
							</ol>
						</div>
					</div>
					<div id="business-information"></div>
					<div className="mt-5 pb-20">
						<h3>Business Information</h3>
						<div className="flex flex-col justify-center items-center">
							<img
								src={require('../../assets/Image/MerchantKYC2.png')}
								alt="MerchantReg"
								className="w-100 mb-2"
								width={500}
								height={667}
							/>
						</div>
					</div>
					<div id="profile-verification"></div>
					<div>
						<h3>Profile Verification</h3>
						<div className="flex flex-col justify-center items-center">
							<img
								src={require('../../assets/Image/MerchantKYC3.png')}
								alt="MerchantReg"
								className="w-100 mb-2 mt-4"
								width={628}
								height={415}
							/>
						</div>
					</div>
					<div id="bank-account-details"></div>
					<div className="mt-10">
						<h3>Bank Account Details</h3>
						<div className="flex flex-col justify-center items-center">
							<img
								src={require('../../assets/Image/MerchantKYC4.png')}
								alt="MerchantReg"
								className="w-100 mb-2 mt-4"
								width={500}
								height={691}
							/>
						</div>
					</div>
					<div className="border-t-2 mt-10 flex flex-row justify-between ">
						<div className="mt-10">
							<p className="text-[12px]">WHATS NEXT? </p>
							<NavLink to="/bank-account-details">
								<p className="text-[#083d8c] text-[16px]">
									Bank Account Details ➔
								</p>
							</NavLink>
						</div>
					</div>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-1">
							<h3>Table of Contents</h3>
						</div>
						<div className="">
							<a href="#kyc-verification">
								<p className="text-sm mb-1 text-[#637288]">KYC Verification</p>
							</a>
							<a href="#business-information">
								<p className="text-sm mb-1 text-[#637288]">
									Business Information
								</p>
							</a>
							<a href="#profile-verification">
								<p className="text-sm mb-1 text-[#637288]">
									Profile Verification
								</p>
							</a>
							<a href="#bank-account-details">
								<p className="text-sm mb-1 text-[#637288]">
									Bank Account Details
								</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
}
